

























































































import { PersonalInfo, LevelProgress, ProfileTiles, SeasonSelect, SkillProgress,
  AchievementsSwiper } from '@/components';
import { Season, OneOfLatestAccomplishments, AchievementsCount, GeekSkill, BadgesCount } from '@/models/geek-profile';
import { geekProfileMixin } from '@/shared';
import { Actions, typedStore } from '@/store';
import Vue from 'vue';
import mixins from 'vue-typed-mixins';

export default mixins(geekProfileMixin).extend({
  name: 'GeekProfileView',
  components: {
    PersonalInfo,
    LevelProgress,
    ProfileTiles,
    SeasonSelect,
    SkillProgress,
    AchievementsSwiper,
  },
  created() {
    this.initializeProfile();
  },
  computed: {
    skillScores(): GeekSkill[] {
      return typedStore(this).state.scores.skillScores;
    },
    achievementsCount(): AchievementsCount {
      return typedStore(this).state.achievements.geekAchievementsCount;
    },
    badgesCount(): BadgesCount {
      return typedStore(this).state.badges.badgesCount;
    },
    tabTitle(): string {
      const activeTabRouteNameSuffix = this.activeRouteName.split('-')[1];
      return this.$t(
        `geek-profile.${activeTabRouteNameSuffix}-tab-${this.getTranslationSuffixOfUser}`,
      ) as string;
    },
    latestGained(): OneOfLatestAccomplishments {
      return typedStore(this).state.history.latestAccomplishment;
    },
  },
  methods: {
    async initializeProfile() {
      this.loader.isProfilePending = true;
      try {
        await this.$store.dispatch(Actions.seasons.fetchAllSeasons),
        await this.$store.dispatch(Actions.seasons.fetchCurrentSeason);
        this.activeSeason = this.$route.query.seasonId
          ? this.seasons.find((s: Season) => s.id === this.$route.query.seasonId) as Season
          : this.currentSeason as Season;
        await Promise.all([
          this.$store.dispatch(Actions.geek.fetchGeekBasicInfo, this.profileId),
          this.$store.dispatch(Actions.achievements.fetchGeekAchievementsCount, this.profileId),
          this.$store.dispatch(Actions.achievements.fetchGeekAchievements, this.profileId),
          this.$store.dispatch(Actions.badges.fetchGeekBadgesCount, this.profileId),

          // TO-DO
          // this is temporary solution, permissions based action dispatcher should be implemented later
          this.$isAccessible(this.$permissions.opportunity)
          ? this.$store.dispatch(Actions.opportunities.fetchGeekOpportunitiesCount, this.profileId)
          : null,

          this.$store.dispatch(
            Actions.scores.fetchGeekGeneralScore,
            { seasonId: this.activeSeason.id, geekId: this.profileId },
          ),
          this.$store.dispatch(
            Actions.scores.fetchGeekSkillScores,
            { seasonId: this.activeSeason.id, geekId: this.profileId },
          ),
          this.$store.dispatch(Actions.history.fetchLatestAccomplishment, this.profileId),
        ]);
      } finally {
        this.loader.isProfilePending = false;
      }
    },
  },
});
